import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import Layout from "../../component/layout/Layout";
import FaqListContainer from "./container/FAQListContainer"

const FAQListPage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <FaqListContainer />
            </Layout>
        </Provider>
    );
};

export default FAQListPage;
